export class DataSheetReport {
    calculationType: number;
    projectDetails?: ProjectDetails;
    traceability?: Traceability;
    standardOrCustomFlange?: StandardOrCustomFlange;
    boltDetails?: BoltDetails;
    tighteningValues?: TighteningValues;
    torqueDetails?: TorqueDetailsDataSheet;
    tensionDetails: TensionDetailsDataSheet;
    clampDataSheet?: ClampDataSheet;
    engineeredJointDataSheet?: EngineeredJointDataSheet;
    notes?: string[];
    warnings?: string[];
    language: string;
    barcode?: string;
    barCodeNumber?: string;
    isBarcodeVisible?: string;
    isQRcodeVisible?: string;
}

export class ProjectDetails {
    customer?: string;
    preparedBy?: string;
    preparedDate?: string;
    comments?: string;
}

export class Traceability {
    boltLoadSource?: string;
    dataSheetRef?: string;
}

export class StandardOrCustomFlange {
    standard?: string;
    pipeSize?: string;
    flangeClass?: string;
    flangeMaterial?: string;
    gasketMaterial?: string;
    jointType?: string;
}

export class BoltDetails {
    numberOfBolts?: string;
    boltMaterial: string;
    minBoltLengthImperial?: string;
    minBoltLengthMetric?: string;
    boltSize: string;
    nutAFImperial?: string;
    nutAFMetric?: string;
    yieldStressImperial?: string;
    yieldStressMetric?: string;
    lubricantCOF?: string;
}

export class TighteningValues {
    residualBoltStressImperial?: string;
    residualBoltStressMetric?: string;
    residualBoltLoadImperial?: string;
    residualBoltLoadMetric?: string;
    yieldResidualPercentage?: string;
    tighteningMethod?: string;
    appliedBoltStressImperial?: string;
    appliedBoltStressMetric?: string;
    appliedBoltLoadMetric?: string;
    appliedBoltLoadImperial?: string;
    yieldAppliedPercentage?: string;
}

export class TorqueDetailsDataSheet {
    tool?: string;
    maxWPImperial?: string;
    maxWPMetric?: string;
    maxTorqueMetric?: string;
    maxTorqueImperial?: string;
    requiredTorqueMetric?: string;
    requiredTorqueImperial?: string;
    requiredPressureMetric?: string;
    requiredPressureImperial?: string;

    // pressure values
    requiredPressure1Metric?: string;
    requiredPressure1Imperial?: string;
    requiredPressure2Metric?: string;
    requiredPressure2Imperial?: string;
    requiredPressure3Metric?: string;
    requiredPressure3Imperial?: string;
    requiredPressure4Metric?: string;
    requiredPressure4Imperial?: string;

    // torque values
    requiredTorque1Metric?: string;
    requiredTorque1Imperial?: string;
    requiredTorque2Metric?: string;
    requiredTorque2Imperial?: string;
    requiredTorque3Metric?: string;
    requiredTorque3Imperial?: string;
    requiredTorque4Metric?: string;
    requiredTorque4Imperial?: string;

    // pass percentage  value
    pass1Percentage?: string;
    pass2Percentage?: string;
    pass3Percentage?: string;
    pass4Percentage?: string;
}

export class TensionDetailsDataSheet {
    tool?: string;
    maxWPMetric?: string;
    maxWPimperial?: string;
    //maxTorqueInNm?: string;
    maxLoadMetric?: string;
    maxLoadImperial?: string;
    maxStrokeMetric?: string;
    maxStrokeImperial?: string;
    toolCoverPercentage?: string;
    equivalentTorqueMetric?: string;
    equivalentTorqueImperial?: string;
    pass1Metric?: string;
    pass1Imperial?: string;
    pass2Metric?: string;
    pass2Imperial?: string;
    pass3Metric?: string;
    pass3Imperial?: string;
    pass4Metric?: string;
    pass4Imperial?: string;
}

export class ClampDataSheet {
    clampManufacturer: string;
    clampMaterial: string;
    clampSize: string;
    hubMaterial: string;
    sealRingMaterial: string;
    pipeSchedule: string;
}

export class EngineeredJointDataSheet {
    jointConfiguration: string;
    jointThicknessMetric: string;
    jointThicknessImperial: string;
    jointMaterial1: string;
    jointMaterial2: string;
    gasketMaterial: string;
    threadType: string;
}
export interface ReportList {
    reportId: string;
    name: string;
    isCustom: boolean;
    isSelected: boolean;
    editedDate: string;
    isScheduled: boolean;
    isFavourite: boolean;
    canSubscribe: boolean;
    onDemand: boolean;
    supportedFileTypes?: [];
}
